export const COLORS  = {
    borderBlue: '#1B75BC',
    borderGray: '#C9CDD3',
    textBlack: '#262930',
    btnGreen: 'green'
}